import styled from "styled-components";

export const Paragraph = styled.div`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  text-align: left;
  color: #020219;
  line-height: 21px;
`;

export const Success = styled.p`
  font-size: 22px;
`;

export const Icon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 10px;
`;

export const ResentMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SupportMessage = styled.div`
  margin-top: 36px;
  font-size: 13px;
  line-height: 18px;
  color: #757584;
  text-align: left;
`;

export const ErrorMessage = styled.p`
  font-size: 12px;
  color: #de2839;
  text-align: left;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start !important;
  align-items: center;
`;

export const SuccessParagraph = styled.p`
  margin: 0;
  height: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SuccessIcon = styled.img`
  width: 128px;
  height: 128px;
  margin-bottom: 8px;
`;

export const SuccessText = styled.div`
  font-size: 20px;
  text-align: center;
  margin-bottom: 36px;
  max-width: 300px;
`;